import React from 'react';
import StoreSelectionManager from '../common/StoreSelectionManager';

export interface AttractorStoreManagerProps {
    assignedStores: string[];
    onChange: (stores: string[]) => void;
}

const AttractorStoreManager: React.FC<AttractorStoreManagerProps> = ({
    assignedStores,
    onChange
}) => {
    return (
        <StoreSelectionManager
            assignedStores={assignedStores}
            onChange={onChange}
            title="Store Assignments"
            description="Select which stores should display this attractor loop slideshow. Changing this assignment will automatically update the store's sync token."
            modalTitle="Manage Store Assignments"
            modalDescription="Search and select the stores that should display this attractor loop."
        />
    );
};

export default AttractorStoreManager;
